import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

export const EcommerceGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (state.url.includes('/track-shipment')) return true;

  if (authService.authCheckEcommerce()) {
    return true;
  }

  localStorage.removeItem('ec_token');
  return router.createUrlTree(['/ecommerce-login']);
};